import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PageAction } from '../../components/page-actions/page-actions.component';
import { CompositionService } from '@services/compositions/composition.service';
import { CompositionTypeService } from '@services/composition-types/composition-type.service';
import { DataTableComponent, DataTableEvent } from '../../components/data-table/data-table.component';
import { DialogService } from '@services/dialog/dialog.service';

@Component({
    selector: 'app-compositions',
    templateUrl: './compositions.component.html',
    styleUrls: ['./compositions.component.scss'],
    providers: [CompositionService, CompositionTypeService],
    standalone: false
})
export class CompositionsComponent implements OnInit {
  public title = 'Compositions';
  public params: any;
  public pageActions: PageAction[];
  public compositionType: any;
  public columns = [{ prop: 'title', }];

  @ViewChild(DataTableComponent) dataTable: DataTableComponent;

  public deadCompositions = [];

  constructor(
    public compositionService: CompositionService, public compositionTypeService: CompositionTypeService, private router: Router, private activatedRoute: ActivatedRoute,
    private dialogService: DialogService,
  ) {
  }

  async ngOnInit() {
    this.params = { typeId: '5cf5092f0e53d72284c1db89' };
    this.compositionType = await this.compositionTypeService.get('5cf5092f0e53d72284c1db89');
    this.title = 'Compositions of Type: ' + this.compositionType.title;
    this.createPageActions();
    this.getDeadCompositions();
  }

  public onDetail(event: DataTableEvent): void {
    this.router.navigate(['compositions', event.row._id]);
  }

  public onEdit(event: DataTableEvent): void {
    this.router.navigate(['compositions', event.row._id, 'edit']);
  }

  public onCopy(event: DataTableEvent): void {
    this.router.navigate(['compositions', event.row._id, 'copy']);
  }

  public async onRemove(event: DataTableEvent) {
    const res = await this.dialogService.confirm('Remove composition?');
    if (!res) {
      return;
    }

    try {
      await this.compositionService.remove(event.row._id);
      this.dataTable.refresh();
    } catch (error) {
      const message = (error.error.message ? error.error.message : error.message);
      this.dialogService.confirm(message, error.name);
    }
  }

  public async getDeadCompositions() {
    this.deadCompositions = [];
    const result = await this.compositionService.find(0, 100, { typeId: { $exists: false } });
    (result?.data || []).forEach(e => this.deadCompositions.push(e));
  }

  public async removeDeadComposition(id) {
    await this.compositionService.remove(id);
    this.getDeadCompositions();
  }

  private createPageActions(): void {
    this.pageActions = [
      new PageAction({ icon: 'create_new_folder', title: 'Create new Composition', callback: () => this.router.navigate(['compositions', 'create', this.compositionType._id]) })
    ];
  }
}
